<template>
  <div class="listParts_wrapper mainJoin_list_Wrapper">
    <div class="title_area wrapper">
      <h4>参加者</h4>
    </div>
    <div class="mainJoin_list_Inner">
      <ul class="mainJoin_list listStyle_normalFlex">
        <li
          class="list selected"
          :class="{leaved: !participant.isActive}"
          v-for="(participant, id) in $store.getters['participants/getExceptSelf'](this.$store.getters['auth/id'])"
          :key="id"
        >
          <a
            class="txtLink_w"
            @click="
              multipleMethod(participant.id)
              updateMessageToRead()
            "
          >
            <div class="pIcon_wrapper"><img :class="{isAdmin: participant.isAdmin()}" :src="participant.avatar" /></div>
            <p class="mainJoin_member_info">
              <span class="cp_tooltiptext degree">{{ participant.organization }}</span>
              <span>{{ participant.name }}</span>
            </p>
            <div class="icon_wrapper">
              <fa-icon :icon="['far', 'envelope']" />
            </div>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade">
      <Modal v-show="showModal" @close="invertModalStatus">
        <div slot="content">
          <div class="content-header inner">
            <h2>
              <span>{{ targetUser.name }}</span>
            </h2>
            <button @click="invertModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <div class="chats">
            <Message
              v-for="(directMessage, index) in messages"
              :key="index"
              :direct-message="directMessage"
              :target-user="targetUser"
              @invert-modal-status="invertModalStatus"
            />
          </div>

          <div class="submitChat">
            <MessageForm @dispatch-dm="dispatchDm" />
<!-- https://valeur.backlog.jp/view/YOSHIDA_HP_MANAGE-4113 トークルーム機能を非表示中 -->
<!--            <div class="submit-invitation">-->
<!--              <SubmitInvitationButton @dispatch-invite-dm="inviteDm" />-->
<!--              <div class="about-talkRoom inner" @mouseover="mouseOverAction" @mouseleave="mouseLeaveAction">-->
<!--                <transition name="fade">-->
<!--                  <div class="mouseOver-content inner" v-if="hoverFlag">-->
<!--                    <span>招待を送った相手と１対１でビデオ通話をすることができます。</span>-->
<!--                  </div>-->
<!--                </transition>-->
<!--                <fa-icon icon="question-circle" />-->
<!--                <span>トークルームとは</span>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Modal from "../elements/Modal"
import Message from "../elements/Message"
import MessageForm from "../elements/MessageForm"
import SubmitInvitationButton from "../elements/SubmitInvitationButton"
import {DirectMessage} from "socket_if"

export default {
  name: "Participants",
  components: {
    Modal,
    Message,
    MessageForm,
    SubmitInvitationButton
  },
  data() {
    return {
      showModal: false,
      hoverFlag: false,
      targetUser: {}
    }
  },
  computed: {
    messages() {
      const messages = this.$store.getters["directMessages/getByUserId"](this.targetUser.id)
      this.scrollToEnd()
      return messages
    }
  },
  methods: {
    multipleMethod(targetUserId) {
      this.setTargetUser(targetUserId)
      this.invertModalStatus()
    },
    setTargetUser(targetUserId) {
      this.targetUser = this.$store.getters["participants/getByUserId"](targetUserId)
    },
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    mouseOverAction() {
      this.hoverFlag = true
    },
    mouseLeaveAction() {
      this.hoverFlag = false
    },
    dispatchDm(message) {
      this.$socket.dispatcher.sendDirectMessage(
        new DirectMessage({
          message: message,
          type: 1, // type: "1: message, 2: invaite"
          fromParticipantId: this.$store.getters["auth/id"],
          toParticipantId: this.targetUser.id,
          isRead: false,
          createdAt: this.$moment.now().toString()
        })
      )
    },
    inviteDm() {
      this.$socket.dispatcher.inviteDirectMessage(
        new DirectMessage({
          message: null,
          type: 2,
          fromParticipantId: this.$store.getters["auth/id"],
          toParticipantId: this.targetUser.id,
          isRead: false,
          createdAt: this.$moment.now().toString()
        })
      )
    },
    updateMessageToRead() {
      _(this.messages)
        .filter(message => {
          return !message.isRead
        })
        .forEach(message => {
          message.isRead = true
          this.$socket.dispatcher.updateDirectMessageToRead(new DirectMessage(message))
        })
    },
    scrollToEnd() {
      this.$nextTick(() => {
        const container = this.$el.querySelector(".modal-mask .chats")
        container.scrollTop = container.scrollHeight
      })
    }
  }
}
</script>

<style scoped></style>
